import type { NavLinkComponent } from "@luckymenu/ui-web";
import { Link, type LinkProps } from "@tanstack/react-router";

/** Lets ui-web's navigation use TanStack Router links. */
export const RouterLink: NavLinkComponent = ({ href, ...rest }) => (
	<Link to={href as LinkProps["to"]} {...rest} />
);
